import { NavIcon } from './NavIcons';
import { CPU_LEVELS, CPU_LEVEL_LABEL, type CpuLevel } from '../lib/cpu';

export interface PlayMode {
  vsCpu: boolean;
  level: CpuLevel;
}

interface Props {
  value: PlayMode;
  onChange: (m: PlayMode) => void;
  /** Label for the two-human option, e.g. "2 Players · same keyboard". */
  twoPlayerLabel: string;
  compact?: boolean;
}

/** "vs Bot" (the default, with difficulty) or "2 Players". */
export function ModePicker({ value, onChange, twoPlayerLabel, compact }: Props) {
  return (
    <div className={`mode-picker${compact ? ' mode-picker--compact' : ''}`}>
      <fieldset className="seg">
        <legend className="visually-hidden">Who’s playing</legend>
        <label className={`seg__opt${value.vsCpu ? ' is-on' : ''}`}>
          <input type="radio" name="vs" checked={value.vsCpu} onChange={() => onChange({ ...value, vsCpu: true })} />
          <NavIcon name="solo" size={16} /> vs Bot
        </label>
        <label className={`seg__opt${!value.vsCpu ? ' is-on' : ''}`}>
          <input type="radio" name="vs" checked={!value.vsCpu} onChange={() => onChange({ ...value, vsCpu: false })} />
          <NavIcon name="multi" size={16} /> {twoPlayerLabel}
        </label>
      </fieldset>
      {value.vsCpu && (
        <fieldset className="seg seg--levels">
          <legend className="visually-hidden">Difficulty</legend>
          {CPU_LEVELS.map((l) => (
            <label key={l} className={`seg__opt${value.level === l ? ' is-on' : ''}`}>
              <input type="radio" name="level" checked={value.level === l} onChange={() => onChange({ ...value, level: l })} />
              {CPU_LEVEL_LABEL[l]}
            </label>
          ))}
        </fieldset>
      )}
    </div>
  );
}
